export default __webpack_public_path__ + "static/media/33.e71e11bf.jpg";